<script setup lang="ts">
const props = defineProps({
    formHelperConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                helperText: rawValue => rawValue?.helperText === undefined || typeof rawValue?.helperText === 'string',
                maxLength: rawValue => rawValue?.maxLength === undefined || typeof rawValue?.maxLength === 'number',
                value: rawValue => rawValue?.value === undefined || typeof rawValue?.value === 'string',
            }

            return Object.values(validations).every(validation => validation(rawValue))
        }
    }
})

// Compute remaining characters
const remainingChars = computed(() => (props.formHelperConfig.maxLength && props.formHelperConfig.value) ? props.formHelperConfig.maxLength - props.formHelperConfig.value?.length : props.formHelperConfig.maxLength)
</script>

<template>
    <div class="form-helper">
        <span v-if="formHelperConfig.helperText" class="helper-text">
            {{ formHelperConfig.helperText }}
        </span>

        <p v-if="formHelperConfig.maxLength" class="char-counter">
            <span>{{ remainingChars }} </span> / {{ formHelperConfig.maxLength }}
        </p>
    </div>
</template>

<style lang="scss">
.form-helper {
    display: grid;
    grid-template-columns: 1fr auto;
}

.helper-text {
    @include helper-text;
}

.char-counter {
    @include char-counter
}
</style>
